"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const coreValues = [{
  num: "01",
  title: "Persoonsgerichte aanpak",
  desc: "Zorg die volledig is afgestemd op uw individuele situatie, wensen en dagelijkse gewoonten. U staat centraal in alles wat we doen.",
  layoutClasses: "col-span-1 md:col-span-6 lg:col-span-4 lg:col-start-1 lg:mt-12"
}, {
  num: "02",
  title: "Vaste zorgverleners",
  desc: "We werken waar mogelijk met een vast team van zorgverleners. Dit zorgt voor een vertrouwd gezicht, rust en continuïteit in uw thuissituatie.",
  layoutClasses: "col-span-1 md:col-span-6 lg:col-span-4 lg:col-start-8 lg:mt-32"
}, {
  num: "03",
  title: "Cultuursensitief",
  desc: "We hebben oprecht aandacht en respect voor uw religieuze, culturele en persoonlijke achtergrond. Zorg moet passen bij wie u bent.",
  layoutClasses: "col-span-1 md:col-span-6 lg:col-span-4 lg:col-start-3 lg:mt-16"
}, {
  num: "04",
  title: "Gediplomeerde professionals",
  desc: "Ons team bestaat uit deskundige, gekwalificeerde en betrokken medewerkers die passie hebben voor hun vak en hart voor de zorg.",
  layoutClasses: "col-span-1 md:col-span-6 lg:col-span-4 lg:col-start-9 lg:-mt-12"
}, {
  num: "05",
  title: "Kwaliteit & Veiligheid",
  desc: "Betrouwbare zorg van het hoogste niveau, waarbij respect, duidelijke communicatie en uw veiligheid altijd voorop staan.",
  layoutClasses: "col-span-1 md:col-span-8 md:col-start-3 lg:col-span-4 lg:col-start-5 lg:mt-24"
}];
function ValueItem({
  item,
  index
}: {
  item: typeof coreValues[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    rootMargin: "0px 0px -50px 0px"
  });
  return <div ref={ref} data-index={index} className={`flex flex-col gap-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"} ${item.layoutClasses}`}>
      <div className="flex items-baseline gap-4">
        <span className="text-6xl md:text-7xl font-serif text-chart-2 tracking-tighter opacity-80">
          {item.num}
        </span>
        <div className="h-px flex-1 bg-border/60 mt-auto mb-4 hidden sm:block"></div>
      </div>
      <div>
        <h3 className="text-2xl font-medium text-foreground mb-3 tracking-tight">
          {item.title}
        </h3>
        <p className="text-muted-foreground leading-relaxed text-lg">
          {item.desc}
        </p>
      </div>
    </div>;
}
export default function WaaromKiezenVoorCuraNovaZorg() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="waarom-kiezen-voor-curanova-zorg" className="py-24 md:py-32 bg-background overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`max-w-3xl mb-20 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-serif text-foreground tracking-tight mb-6">
            Waarom kiezen voor <br className="hidden sm:block" />
            <span className="text-primary">CuraNova Zorg</span>
          </h2>
          <p className="text-xl text-muted-foreground leading-relaxed">
            Wij geloven dat goede zorg verder gaat dan alleen medische of praktische ondersteuning. 
            Het draait om oprechte aandacht, vertrouwen en het behouden van uw eigen regie.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-x-8 gap-y-16 md:gap-y-24">
          {coreValues.map((item, i) => <ValueItem key={item.num} item={item} index={i} />)}
        </div>
      </div>
    </section>;
}